import React from "react";
import styled from "styled-components";
import { media } from "../../src/styles/media";

import { translate } from "react-i18next";
import { IntroMedia } from "../../src/components/Layout/Media";
import { Container } from "../../src/components/Grid";

const RootStory = styled.div`
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
  padding-top: 2rem;

  ${media.desktop`
    padding-top: 10rem;
  `};
`;

const Story = ({ t }) => (
  <RootStory>
    <Container>
      <IntroMedia
        title={t("common:application.first_paragraph.title")}
        img="/static/images/application/image-1.jpg"
      >
        {t("common:application.first_paragraph.content")}
      </IntroMedia>
      <IntroMedia
        title={t("common:application.second_paragraph.title")}
        img="/static/images/application/image-2.jpg"
        reverse
      >
        {t("common:application.second_paragraph.content")}
      </IntroMedia>
    </Container>
  </RootStory>
);

export default translate()(Story);
